import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { getAppStore } from '@/store';
import { clearAllGenerations } from '@/utils/storage/generationStorage';

export const logout = async (): Promise<void> => {
  try {
    await clearAllGenerations();
    getAppStore().resetAll(); // Clear in-memory generation state
    const result = await getContext().handlers.publishEvent({
      event: 'logout',
    });
    if (result) {
      await getContext().handlers.refreshToken();
    }
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN);
  }
};

export const deleteAccount = async (): Promise<void> => {
  try {
    await getContext().handlers.publishEvent({ event: 'delete_account' });
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN);
  }
};
